import React from 'react';
import loader from '../assets/images/loader.gif';
import loader1 from '../assets/images/loader1.gif';
import loader2 from '../assets/images/loader2.gif';
import LoaderProp from './properties/LoaderProp';

function Loader({ width, imageNumber }: LoaderProp): React.ReactElement {
  let view = <img style={{ width }} src={loader} alt="loading..." />;
  switch (imageNumber) {
    case '1':
      view = <img style={{ width, background: 'none' }} src={loader1} alt="loading..." />;
      break;
    case '2':
      view = <img style={{ width, background: 'none' }} src={loader2} alt="loading..." />;
      break;
    default:
      view = <img style={{ width, background: 'none' }} src={loader} alt="loading..." />;
  }
  return (
    view
  );
}

export default Loader;
